import { DropdownMenuOption } from '@ardoq/dropdown-menu-ui';
import { IconName } from '@ardoq/icons';
import { ComponentType } from 'react';
import { NoticeProps } from 'react-select';
import { SelectOption } from '../../types';
import { t } from '@ardoq/i18n';
import { getI18nLocaleFromSelectProps } from './getI18nLocaleFromSelectProps';

export const LoadingMessage: ComponentType<
  NoticeProps<SelectOption<unknown>>
> = ({ selectProps: { inputValue, loadingMessage, ...rest } }) => {
  const i18nLocale = getI18nLocaleFromSelectProps(rest);
  return (
    <DropdownMenuOption
      label={
        loadingMessage
          ? loadingMessage({ inputValue })
          : t(i18nLocale, 'select:loading', 'Loading results...')
      }
      leftIconName={IconName.SPINNER}
      align="center"
    />
  );
};
